import { render } from "./MagentoAbout.vue?vue&type=template&id=36f15225"
import script from "./MagentoAbout.vue?vue&type=script&lang=js"
export * from "./MagentoAbout.vue?vue&type=script&lang=js"

import "./MagentoAbout.vue?vue&type=style&index=0&id=36f15225&lang=scss"

import exportComponent from "/home/webdevs/livesite/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__